import { useEffect, useLayoutEffect } from "react";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import { COMMAND_PRIORITY_CRITICAL, KEY_ENTER_COMMAND } from "lexical";

const OnKeyDownPlugin = ({
  onKeyDown,
}: {
  onKeyDown: (_event: KeyboardEvent) => void;
}) => {
  const [editor] = useLexicalComposerContext();
  useLayoutEffect(() => {
    return editor.registerRootListener(
      (
        rootElement: null | HTMLElement,
        prevRootElement: null | HTMLElement
      ) => {
        if (prevRootElement !== null) {
          prevRootElement.removeEventListener("keydown", onKeyDown);
        }
        if (rootElement !== null) {
          rootElement.addEventListener("keydown", onKeyDown);
        }
      }
    );
  }, [editor, onKeyDown]);

  useEffect(() => {
    mergeRegister(
      editor.registerCommand(
        KEY_ENTER_COMMAND,
        (payload) => {
          const event: KeyboardEvent = payload!;
          onKeyDown(event);
          return true;
        },
        COMMAND_PRIORITY_CRITICAL
      )
    );
  }, [editor, onKeyDown]);

  return <></>;
};

export default OnKeyDownPlugin;
